package com.evoapps.evoshift.data.repository

import com.evoapps.evoshift.data.remote.AppFirestore
import com.evoapps.evoshift.domain.repository.RoleSkillsUpdate
import com.evoapps.evoshift.domain.repository.TeamBulkRepository

/**
 * SH-269: several people's position and skills at one workplace in one batch, field by field as
 * UserRepositoryImpl.updateEmployeeDetailsFull writes them (typed values: a list inside a map does
 * not encode on Kotlin/JS). One engagement per profile, as firestore.rules require.
 */
class TeamBulkRepositoryImpl(private val firestore: AppFirestore) : TeamBulkRepository {
    override suspend fun updateRolesAndSkills(workplaceId: String, updates: List<RoleSkillsUpdate>): Result<Unit> = runCatching {
        updates.filter { it.role != null || it.skills != null }.chunked(PER_BATCH).forEach { chunk ->
            val batch = firestore.batch()
            chunk.forEach { update ->
                val role = update.role
                val skills = update.skills
                batch.updateFields(firestore.collection("users").document(update.userId)) {
                    if (role != null) "engagements.$workplaceId.role" to role
                    if (skills != null) "engagements.$workplaceId.skills" to skills
                }
            }
            batch.commit()
        }
    }

    private companion object {
        /** Firestore takes 500 writes a batch. */
        const val PER_BATCH = 400
    }
}
